/**
 * Card surface style props shared by the restaurant profile page and its
 * route-level skeleton, so the skeleton's silhouette cannot drift from the page.
 * Lives in `styles/` (no component imports) to stay free of circular imports.
 */
export const cardSurfaceProps = {
  bg: 'var(--card-bg)',
  borderRadius: 'var(--r-card)',
  boxShadow: 'var(--card-shadow)',
} as const;
